export default "__VITE_ASSET__Dla9gE7N__"